export default "__VITE_ASSET__1ccd0c5e__"